module.exports = __webpack_public_path__ + "static/media/about-1.c0c386b5.jpg";